import { useDispatch, useSelector  } from "react-redux";
import { RootState } from "../../../store/store";
import Banner from "./components/Banner";
import CutOffs from "./components/CutOffs";
import Details from "./components/Details";
import KnowledgeHub from "./components/KnowledgeHub";
import Rankings from "./components/Rankings";
import { AppDispatch } from "../../../store/store";
import { useEffect } from "react";
import { fetchLandingData } from "./collegePredictorIntermediateThunk";
import PredictionForm from "./components/PredictionForm";
import Testimonial from "./components/Testimonial";
import { useParams } from "react-router-dom";
import Loader from "../../../components/Loader/Loader";
import "./CollegePredictorIntermediate.scss";

const CollegePredictorIntermediate = () => {
  const dispatch = useDispatch<AppDispatch>();
  const landingData = useSelector((state: RootState) => state.collegePredictorIntermediate.landingData);
  const { exam } = useParams();

  useEffect(() => {
    dispatch(fetchLandingData(exam || ""));
  }, [exam]);

  return (
    <div className="font-inter flex flex-col">
      <Banner />
      <PredictionForm />
      <Details />
      {landingData?.cutOffs && <CutOffs />}
      <KnowledgeHub />
      <Testimonial />
      <Rankings />
    </div>
  );
};

export default CollegePredictorIntermediate;
